import type { DatePickerProps } from '@_/ui';
import { DateTime } from 'luxon';
import { useCallback, useMemo } from 'react';
import { FormattedRelativeTime } from 'react-intl';
import { ChipToggleGroup, ChipToggleGroupOption } from '@_/ui';

export function RelativeDateToggleGroup({
  offsets,
  onChange,
  ranged,
  value
}: Pick<DatePickerProps, 'onChange' | 'ranged' | 'value'> & {
  offsets: number[];
}) {
  const relativeDays = useMemo(() => {
    if (
      Array.isArray(value) &&
      (value.length === 1 || (value.length === 2 && value[1].equals(value[0].plus({ day: 1 }))))
    ) {
      const today = DateTime.local().startOf('day');
      return value[0].diff(today).shiftTo('day').days;
    }

    return null;
  }, [value]);

  const handleChange = useCallback(
    (strOffset: string | undefined) => {
      if (typeof strOffset === 'undefined' || strOffset === '') {
        return;
      }

      const offset = parseInt(strOffset, 10);

      const date = DateTime.local().startOf('day').plus({ day: offset });
      const result = ranged ? [date, date] : [date];
      onChange?.(result);
    },
    [onChange, ranged]
  );

  return (
    <ChipToggleGroup multiple={false} onChange={handleChange} value={relativeDays?.toString()}>
      {offsets.map(offset => (
        <ChipToggleGroupOption key={offset} value={offset.toString()}>
          <span className="capitalize">
            <FormattedRelativeTime numeric="auto" style="short" unit="day" value={offset} />
          </span>
        </ChipToggleGroupOption>
      ))}
    </ChipToggleGroup>
  );
}
